import { Speaker } from '../lib/api';

export const defaultConfirmedSpeakers: Speaker[] = [
  {
    id: '77777777-1111-1111-1111-000000000001',
    fullName: 'Dr. Ramesh Chand',
    email: 'anita.agarwal+vip1@rayconsulting.in',
    phone: '+91 98101 11223',
    organization: 'NITI Aayog (Govt of India)',
    designation: 'Union Policy Member (Agriculture)',
    bio: 'Eminent agricultural economist leading national policy formulation on minimum support pricing, digital public agri-stack, and international commodity trade.',
    headshotUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300',
    linkedinUrl: 'https://linkedin.com/in/dr-ramesh-chand-niti',
    topicTitle: 'National Blueprint for Agritech Innovation & Global Agri-Export Parity',
    topicAbstract: 'High-level ministerial plenary outlining public-private frameworks, regulatory harmonization for agricultural drones, and Indias emergence as a sustainable bio-economy supplier.',
    track: 'Policy, Global Trade & Market Access',
    status: 'approved',
    isFeatured: true,
    stageOrHall: 'Main Plenary Hall',
    sessionDate: '2027-07-27',
    sessionStartTime: '10:00',
    sessionEndTime: '10:45',
  },
  {
    id: '77777777-1111-1111-1111-000000000002',
    fullName: 'Dr. Himanshu Pathak',
    email: 'raj.agarwal+vip1@rayconsulting.in',
    phone: '+91 98102 33445',
    organization: 'ICAR (Indian Council of Agricultural Research)',
    designation: 'Director General & Secretary (DARE)',
    bio: 'Global authority on climate-smart agriculture, soil nitrogen balance, and indigenous bio-fertilizer commercialization with 250+ peer-reviewed papers.',
    headshotUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=300',
    linkedinUrl: 'https://linkedin.com/in/dr-himanshu-pathak-icar',
    topicTitle: 'Climate-Resilient Agriculture & Indigenous Bio-Stimulant Formulations',
    topicAbstract: 'Scientific review of validated microbial inoculants, nano-fertilizers, and field efficacy benchmarks for mitigating extreme heat and water stress across Indian cropping zones.',
    track: 'Biologicals & Biofertilizers',
    status: 'approved',
    isFeatured: true,
    stageOrHall: 'Main Plenary Hall',
    sessionDate: '2027-07-27',
    sessionStartTime: '11:15',
    sessionEndTime: '12:00',
  },
  {
    id: '77777777-1111-1111-1111-000000000003',
    fullName: 'Shashank Kumar',
    email: 'raj.agarwal+exh2@rayconsulting.in',
    phone: '+91 98101 22334',
    organization: 'DeHaat Agri Revolution',
    designation: 'Co-Founder & CEO',
    bio: 'IIT Delhi alumnus who built India’s largest full-stack agritech network serving over 2.7 million farmers across 11 states with AI-driven farm advisory.',
    headshotUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300',
    linkedinUrl: 'https://linkedin.com/in/shashank-kumar-dehaat',
    topicTitle: 'Hyperlocal AI & Satellite Imagery in Smallholder Farm Underwriting',
    topicAbstract: 'Architectural breakdown of deploying multimodal vision transformers and soil sensor fusion to predict harvest yields, optimize seed delivery, and automate micro-credit underwriting.',
    track: 'Agritech, AI & Precision Farming',
    status: 'approved',
    isFeatured: true,
    stageOrHall: 'Conference Hall 1',
    sessionDate: '2027-07-27',
    sessionStartTime: '14:00',
    sessionEndTime: '14:45',
  },
  {
    id: '77777777-1111-1111-1111-000000000005',
    fullName: 'Anand Deshmukh',
    email: 'raj.agarwal+exh1@rayconsulting.in',
    phone: '+91 98334 56789',
    organization: 'UPL Global Sustainable Agri',
    designation: 'Director of Sustainable Outreach & Carbon Farming',
    bio: 'Overseeing global regenerative agriculture partnerships, soil carbon sequestration credits, and organic bio-stimulant field adoption across 4 continents.',
    headshotUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=300',
    linkedinUrl: 'https://linkedin.com/in/anand-deshmukh-upl',
    topicTitle: 'Soil Microbiome Regeneration: Re-engineering Active Ingredients for Bio-Safety',
    topicAbstract: 'Case studies on dual-mode crop protection where beneficial mycorrhizae and biological consortia work synergistically with reduced chemical pesticide doses.',
    track: 'Sustainable Formulation Chemistry',
    status: 'approved',
    isFeatured: true,
    stageOrHall: 'Technical Breakout A',
    sessionDate: '2027-07-28',
    sessionStartTime: '10:00',
    sessionEndTime: '10:45',
  },
  {
    id: '77777777-1111-1111-1111-000000000004',
    fullName: 'Dr. Sunita Malhotra',
    email: 'raj.agarwal+del3@rayconsulting.in',
    phone: '+91 98192 88776',
    organization: 'Bayer CropScience India Ltd',
    designation: 'Chief Scientist & Head of Formulation R&D',
    bio: '22 years leading agrochemical research with specialization in low-VOC formulations, adjuvant chemistry, and ultra-low-volume aerial spraying compounds.',
    headshotUrl: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=300',
    linkedinUrl: 'https://linkedin.com/in/dr-sunita-malhotra-bayer',
    topicTitle: 'Next-Gen Drone-Compatible Micro-Emulsions & Green Solvents',
    topicAbstract: 'Addressing drift reduction, surface tension optimization, and eco-toxicology compliance in next-generation crop protection spraying via automated commercial UAVs.',
    track: 'Agrochemicals & Crop Protection',
    status: 'approved',
    isFeatured: false,
    stageOrHall: 'Conference Hall 2',
    sessionDate: '2027-07-27',
    sessionStartTime: '15:15',
    sessionEndTime: '16:00',
  },
  {
    id: '77777777-1111-1111-1111-000000000006',
    fullName: 'Siddharth Jain',
    email: 'shubhang+exh2@rayconsulting.in',
    phone: '+91 98220 98765',
    organization: 'Jain Irrigation Systems Ltd',
    designation: 'Chief Marketing & Sustainability Officer',
    bio: 'Driving global expansion of micro-irrigation, solar water lifting schemes, and smart fertigation sensors across Africa, Asia, and Latin America.',
    headshotUrl: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=300',
    linkedinUrl: 'https://linkedin.com/in/siddharth-jain-irrigation',
    topicTitle: 'Solar-Powered Micro-Cold Rooms & Farm-Gate Pre-Cooling Infrastructure',
    topicAbstract: 'Bridging the 30% perishables loss gap through distributed off-grid cooling modules, IoT temperature telemetry, and integrated reefer transport networks.',
    track: 'Post-Harvest & Cold Chain Innovations',
    status: 'approved',
    isFeatured: false,
    stageOrHall: 'Technical Breakout B',
    sessionDate: '2027-07-28',
    sessionStartTime: '11:15',
    sessionEndTime: '12:00',
  },
  {
    id: '77777777-1111-1111-1111-000000000007',
    fullName: 'Vikramaditya Singhania',
    email: 'shubhang+vip1@rayconsulting.in',
    phone: '+91 98110 54321',
    organization: 'AgriHorizon Robotics Pvt Ltd',
    designation: 'Managing Director & Founder',
    bio: 'Pioneering field robotics, LiDAR-guided weed eradicators, and electric heavy-duty autonomous agricultural tractors in India.',
    headshotUrl: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=300',
    linkedinUrl: 'https://linkedin.com/in/vikram-singhania-robotics',
    topicTitle: 'Autonomous Field Robotics & Heavy Machinery Electrification in 2027',
    topicAbstract: 'Live technical demo of optical weed differentiation and battery-swapping architecture engineered for 24-hour continuous farm tillage in Indian conditions.',
    track: 'Agritech, AI & Precision Farming',
    status: 'approved',
    isFeatured: false,
    stageOrHall: 'Exhibition Presentation Stage',
    sessionDate: '2027-07-28',
    sessionStartTime: '14:00',
    sessionEndTime: '14:45',
  },
];
